import { ref, inject } from 'vue';
import {
  MY_PREFECTURE,
  DEFAULT_PREFECTURE,
  MY_CORPORATION,
  COOKIE_EXPIRE,
} from '@/constants/common';

export default function () {
  const $cookie = inject('$cookie');

  let myCodeId = $cookie.get(MY_PREFECTURE);
  if (myCodeId) {
    myCodeId = myCodeId.toString();
  } else {
    myCodeId = DEFAULT_PREFECTURE;
  }

  let myCorporation = $cookie.get(MY_CORPORATION);
  if (!myCorporation) {
    myCorporation = 1;
  } else {
    myCorporation = myCorporation.split(',');
  }

  const setPrefectureCode = (prefectureCode) => {
    $cookie.set(MY_PREFECTURE, prefectureCode, { expires: COOKIE_EXPIRE });
  };

  const myPrefectureCode = ref(myCodeId);
  return { myPrefectureCode, myCorporation, setPrefectureCode };
}
